import {DECIMAL_DIGIT} from '../constants/App'

/** 演算処理ユーティリティ */

/** 2点間距離 */
export const dist = (x1, y1, x2, y2) => {
  return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2))
}

/** 桁指定で四捨五入 */
export const round = (number, digit = DECIMAL_DIGIT) => {
  let pow = Math.pow(10, digit)
  return Math.round(number * pow) / pow
}

/** サイズを適切な単位に変換する */
export const convertByte = (size) => {
  const { target, unit } = getTargetUnit(size)
  const newSize = target !== null ? Math.floor((size / target) * Math.pow(10, 2)) / Math.pow(10, 2) : size
  return newSize + unit
}

/** 引数のサイズを元に計算につかうバイト数と単位を返却 */
export const getTargetUnit = (size) => {
  if (size == null) return null

  const kb = 1024
  const mb = Math.pow(kb, 2)
  const gb = Math.pow(kb, 3)
  const tb = Math.pow(kb, 4)

  const returnData = (target, unit) => ({ target, unit })

  if (size >= tb) return returnData(tb, 'TB')
  if (size >= gb) return returnData(gb, 'GB')
  if (size >= mb) return returnData(mb, 'MB')
  if (size >= kb) return returnData(kb, 'KB')

  return returnData(null, 'byte')
}



// WEBPACK FOOTER //
// ./src/main/js/utils/Calc.js